import { useQuery } from '@tanstack/react-query';

import { getOfferingTransactionDocumentsAsPdf } from '@arrived/api_v2';
import { OfferingTransactionId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { tradeDocumentsPdfQueryKeyFn } from './trades.keys';

export function useGetTradeDocumentsRawQuery(tradeId: OfferingTransactionId, options?: UseQueryOptions<Blob>) {
  return useQuery(tradeDocumentsPdfQueryKeyFn(tradeId), async () => getOfferingTransactionDocumentsAsPdf(tradeId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
